import { render, staticRenderFns } from "./DepDental.vue?vue&type=template&id=73965fe6&scoped=true&"
import script from "./DepDental.vue?vue&type=script&lang=js&"
export * from "./DepDental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73965fe6",
  null
  
)

export default component.exports